import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=18aef6e0&scoped=true&"
import script from "./CategoryDetail.vue?vue&type=script&lang=js&"
export * from "./CategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDetail.vue?vue&type=style&index=0&id=18aef6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aef6e0",
  null
  
)

export default component.exports